import { ROUTES } from '@/constants/constants';
import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function LegalInfo() {
  const { t, i18n } = useTranslation('web', { keyPrefix: 'components.AuthModal' });
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);

  const handleClose = () => dispatch({ type: AppStateActions.SET_AUTH_STATE, payload: { state: undefined } });

  return (
    <p className="text-center text-[13px] leading-[1.5] text-muted-foreground">
      {t('agreement', { action: authState.state === 'SIGN_IN' ? t('signingIn') : t('creatingAccount') })}{' '}
      <Link
        onClick={handleClose}
        to={ROUTES.terms(i18n.language)}
        className="rounded-sm text-primary hover:underline focus-visible:ring-focus"
      >
        {t('terms')}
      </Link>
      , {t('andOur')}{' '}
      <Link
        onClick={handleClose}
        to={ROUTES.policy(i18n.language)}
        className="rounded-sm text-primary hover:underline focus-visible:ring-focus"
      >
        {t('privacyPolicy')}
      </Link>
    </p>
  );
}

export { LegalInfo };
